// eslint-disable-next-line yola/import/no-webpack-loader-syntax
import styleContent from '!!raw-loader!./reset-styles.css';

const resetStyles = (liveDOM) => {
  const styleElement = liveDOM.createElement('style');
  styleElement.setAttribute('data-reset-stylesheet', true);
  styleElement.innerHTML = styleContent;
  liveDOM.body.insertAdjacentElement('beforeend', styleElement);
};

export default resetStyles;
